import { c as _c } from "react/compiler-runtime";
import { BenefitTiles } from '@/components/tiles';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconPay from '@/assets/icons/heroIcons/Pay.svg';
import IconCard from '@/assets/icons/heroIcons/Credit-card.svg';
import { IconTile } from '@/components/IconTile';
function Benefits() {
  const $ = _c(32);
  const {
    t
  } = useTranslation("exchangeRate");
  let t0;
  if ($[0] !== t) {
    t0 = t("benefitsSection.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="mx-auto w-full max-w-192 text-center"><SectionHeadline className="mb-4" anchorKey="benefitsSection.title">{t0}</SectionHeadline></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("benefitsSection.benefits.1");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconTile icon={<IconCard />} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = {
      title: t2,
      icon: t3
    };
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("benefitsSection.benefits.2");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconTile icon={<IconPay />} />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = {
      title: t5,
      icon: t6
    };
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("benefitsSection.benefits.3");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <IconTile icon={<IconPay />} />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8) {
    t10 = {
      title: t8,
      icon: t9
    };
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t4 || $[21] !== t7) {
    t11 = <div className="my-10 md:my-16"><BenefitTiles items={[t4, t7, t10]} className="px-0" /></div>;
    $[19] = t10;
    $[20] = t4;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = LINKS();
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = t12.registration;
  let t14;
  if ($[24] !== t) {
    t14 = t("benefitsSection.button");
    $[24] = t;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14) {
    t15 = <Button to={t13} testId="exchangeRateBenefitsRegistration" analyticsParam="exchangeRateBenefitsRegistration" size="lg" variant="primary" align="center">{t14}</Button>;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t1 || $[29] !== t11 || $[30] !== t15) {
    t16 = <div className="pt-14 pb-20 lg:py-20">{t1}{t11}{t15}</div>;
    $[28] = t1;
    $[29] = t11;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
}
export default Benefits;